/** @format */
import styled from 'styled-components';

export const StyledFilters = styled.div`
    grid-area: filters;
`;
